import { Select, type SelectOption } from "@legal-500/legal500-design-system";
import { useState } from "react";
import type { StaffArticleType } from "@/api/profiles";
import { PageHeader } from "@/components/PageHeader";
import { CompanyPicker } from "@/components/Profiles/ListFilters";
import styles from "../ProfilesForm.module.css";
import { ArticleForm } from "./ArticleForm";

// staff routes have no `:articleType` segment (unlike account-ui's
// `/:articleType/:id`), so the type is chosen here before the form mounts and
// passed down as `initialArticleType`. Inside the form the type is then locked.
const ARTICLE_TYPE_OPTIONS: SelectOption[] = [
  { value: "doing_business_in", label: "Doing Business In" },
  { value: "focus_on", label: "Focus On" },
  { value: "interview", label: "Interview" },
  { value: "press_release", label: "Press Release" },
  { value: "legal_development", label: "Legal Development" },
];

export function ArticleNew() {
  const [companyId, setCompanyId] = useState<string | null>(null);
  const [articleType, setArticleType] = useState<StaffArticleType>("doing_business_in");

  const ready = Boolean(companyId);

  return (
    <div className={styles.wrapper}>
      <PageHeader title="New article" />

      <section className={styles.section}>
        <div className={styles.fieldGridSingle}>
          <CompanyPicker
            value={companyId}
            onChange={id => setCompanyId(id)}
            label="Firm (required)"
          />
          <Select
            label="Article type"
            value={articleType}
            options={ARTICLE_TYPE_OPTIONS}
            aria-label="Article type"
            onChange={e => setArticleType(e.target.value as StaffArticleType)}
          />
        </div>
        {!ready && (
          <p className={`${styles.muted} ${styles.labelHint}`}>
            Pick a firm to start a new article.
          </p>
        )}
      </section>

      {companyId && <ArticleForm companyId={companyId} initialArticleType={articleType} />}
    </div>
  );
}

export default ArticleNew;
